import { FC } from 'react';
import { translate } from '../../i18n';
import { BlockedCardIcon } from '../CardStatusModal/icons';
import { paymentFailurePanelStyles as styles } from './styles';

export type PaymentFailureVariant = 'cardValidation' | 'paymentDeclined';

export interface PaymentFailurePanelProps {
  variant?: PaymentFailureVariant;
  /** Detalle opcional (p. ej. re-ingresar tarjeta). */
  detail?: string;
  onAction: () => void;
  testID?: string;
}

const titleKey: Record<PaymentFailureVariant, string> = {
  cardValidation: 'paymentsUI.paymentFailure.cardTitle',
  paymentDeclined: 'paymentsUI.paymentFailure.paymentTitle',
};

/**
 * Estado de error de pago / validación de tarjeta (Figma — Paso 4 Pago).
 * Usado inline en web desktop/mobile y dentro del modal en app.
 */
export const PaymentFailurePanel: FC<PaymentFailurePanelProps> = ({
  variant = 'paymentDeclined',
  detail,
  onAction,
  testID = 'payment-failure-panel',
}) => {
  const titleId = `${testID}-title`;
  const detailId = detail ? `${testID}-detail` : undefined;

  return (
  <div style={styles.panel} data-testid={testID} role="alert" aria-labelledby={titleId} aria-describedby={detailId}>
    <div style={styles.iconWrapper}>
      <BlockedCardIcon />
    </div>
    <h2 id={titleId} style={styles.title}>{translate(titleKey[variant])}</h2>
    {detail ? <p id={detailId} style={styles.body}>{detail}</p> : null}
    <p style={styles.hint}>{translate('paymentsUI.paymentFailure.hint')}</p>
    <button type="button" style={styles.actionButton} onClick={onAction} data-testid={`${testID}-action`}>
      {translate('paymentsUI.paymentFailure.action')}
    </button>
  </div>
  );
};
